// extracted by mini-css-extract-plugin
var _1 = "FollowCompanyStyle-module__follow-btn___T8O9R";
var _2 = "FollowCompanyStyle-module__follow-company___B2D1D";
var _3 = "FollowCompanyStyle-module__follow-tooltip___eF3RD";
var _4 = "FollowCompanyStyle-module__follow-btn___T8O9R";
var _5 = "FollowCompanyStyle-module__follow-company___B2D1D";
var _6 = "FollowCompanyStyle-module__follow-tooltip___eF3RD";
var _7 = "FollowCompanyStyle-module__followed-btn___C0h0u";
var _8 = "FollowCompanyStyle-module__followed-btn___C0h0u";
export { _1 as "follow-btn", _2 as "follow-company", _3 as "follow-tooltip", _4 as "followBtn", _5 as "followCompany", _6 as "followTooltip", _7 as "followed-btn", _8 as "followedBtn" }
